import { render, staticRenderFns } from "./AboutYjjM.vue?vue&type=template&id=58a2d4e3&scoped=true&"
import script from "./AboutYjjM.vue?vue&type=script&lang=js&"
export * from "./AboutYjjM.vue?vue&type=script&lang=js&"
import style0 from "./AboutYjjM.vue?vue&type=style&index=0&id=58a2d4e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a2d4e3",
  null
  
)

export default component.exports